export default "__VITE_ASSET__BnpKSL97__"